export const Logo = ({ className = "h-6", dark = false }) => {
  if (dark) {
    return (
      <span className={`font-bold tracking-tight text-[#FAF8F3] text-xl lowercase ${className}`} style={{ fontFamily: "Geist" }}>
        agenzee
      </span>
    );
  }
  return <img src="/assets/agenzee-logo.png" alt="agenzee" className={`${className} w-auto`} />;
};

export const MonoLabel = ({ children, className = "", ...props }) => (
  <span className={`mono-label ${className}`} {...props}>
    {children}
  </span>
);

export const CtaButton = ({ children, className = "", ...props }) => (
  <button className={`cta-btn ${className}`} {...props}>
    <span className="cta-handle tl" />
    <span className="cta-handle tr" />
    <span className="cta-handle bl" />
    <span className="cta-handle br" />
    {children}
  </button>
);

export const SecondaryButton = ({ children, className = "", ...props }) => (
  <button className={`btn-secondary ${className}`} {...props}>
    {children}
  </button>
);

export const Tag = ({ color = "neutral", children, className = "", ...props }) => (
  <span className={`tag tag-${color} ${className}`} {...props}>{children}</span>
);

export const ProgressDots = ({ total, current }) => (
  <div className="flex items-center gap-2.5" data-testid="progress-dots">
    {Array.from({ length: total }).map((_, i) => (
      <span key={i} className={`progress-dot ${i === current ? "active" : i < current ? "done" : ""}`} />
    ))}
  </div>
);
